<!--
  ~ Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
  ~ This software is released under MIT license.
  ~ The full license information can be found in LICENSE in the root directory of this project.
  -->

<button
  type="button"
  class="nav-trigger"
  [class.on-collapse]="collapsed"
  [attr.aria-expanded]="ariaExpanded"
  [attr.aria-label]="commonStrings.keys.verticalNavToggle"
  (click)="toggleByButton()"
  *ngIf="collapsible"
>
  <cds-icon
    shape="angle-double"
    class="nav-trigger-icon"
    [attr.direction]="(this.collapsed) ? 'right' : 'left'"
    [attr.title]="(this.collapsed) ? commonStrings.keys.expand : commonStrings.keys.collapse"
  ></cds-icon>
</button>
<div class="nav-content">
  <ng-content></ng-content>
  <button
    (click)="collapsed = false"
    class="nav-btn"
    aria-hidden="true"
    tabindex="-1"
    [attr.aria-label]="commonStrings.keys.verticalNavToggle"
    *ngIf="collapsible && collapsed"
  ></button>
</div>
